module.exports = __webpack_public_path__ + "static/ServiceAccount-b0db9475cd7e9084c712975d4b11491a.png";